import BaseHttpService from './base-http.service';

export default class NotesService extends BaseHttpService {
  fetchNotes() {
    return this.get('note/notes');
  }

  deleteNote(uuid) {
    return this.post(`note/delete`, {uuid});
  }

  getPaymentPlan() {
    return this.get(`user/payment-plan`);
  }

  updateNote(uuid, toEmail, toName, body) {
    return this.post(`note/update`, { uuid, toEmail, toName, body });
  }

  createNote(toEmail, toName, body) {
    return this.post(`note/create`, { toEmail, toName, body });
  }

  cancelSubscription(dontSendNotes) {
    return this.post(`stripe/cancel-subscription`, { dontSendNotes });
  }
}
